import React from "react";
import { Box, Typography } from "@mui/material";
import styled from "@emotion/styled";
import StepChecklist from "./StepChecklist";

const IntroText = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const ListBlock = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

const StepQuoteScope = ({ form, onChange }) => (
    <Box>
        <IntroText variant="body2" color="text.secondary">
            These lists tell the AI what this engagement normally assumes, includes and excludes, so the drafts it writes from this template say the same thing every time. Leave any of them empty if they don't apply.
        </IntroText>

        <ListBlock>
            <StepChecklist
                heading="Assumptions"
                items={form.assumptions}
                onChange={(items) => onChange({ assumptions: items })}
                helperText="Conditions the scope relies on."
                emptyText="No assumptions yet."
                itemPlaceholder="Assumption"
                addPlaceholder="Add an assumption"
            />
        </ListBlock>

        <ListBlock>
            <StepChecklist
                heading="Inclusions"
                items={form.inclusions}
                onChange={(items) => onChange({ inclusions: items })}
                helperText="What is explicitly in scope."
                emptyText="No inclusions yet."
                itemPlaceholder="Inclusion"
                addPlaceholder="Add an inclusion"
            />
        </ListBlock>

        <ListBlock>
            <StepChecklist
                heading="Exclusions"
                items={form.exclusions}
                onChange={(items) => onChange({ exclusions: items })}
                helperText="What is explicitly out of scope."
                emptyText="No exclusions yet."
                itemPlaceholder="Exclusion"
                addPlaceholder="Add an exclusion"
            />
        </ListBlock>
    </Box>
);

export default StepQuoteScope;
